<template>
  <div>
    <ProgressBar :step="step" :totalSteps="totalSteps" class="w-100 m-auto progress-bar-height" />

    <div v-if="step === 1">
      <StepOne @next="nextStep" />
    </div>
    <div v-if="step === 2">
      <StepTwo @prev="prevStep" @next="nextStep" />
    </div>
    <div v-if="step === 3">
      <StepThree @prev="prevStep" @next="nextStep" />
    </div>
    <div v-if="step === 4">
      <StepFour @prev="prevStep" @next="nextStep" />
    </div>
    <div v-if="step === 5">
      <StepFive @prev="prevStep" @next="nextStep" />
    </div>
    <div v-if="step === 6">
      <StepSix @prev="prevStep" @next="nextStep" />
    </div>
    <div v-if="step === 7">
      <StepSeven @prev="prevStep" @next="nextStep" />
    </div>
  </div>
</template>

<script>
import ProgressBar from '@/components/JobDescription/GeneralComponents/ProgressBar.vue';
import StepOne from './StepOne/StepOne.vue';
import StepTwo from './StepTwo/StepTwo.vue';
import StepThree from '@/components/JobDescription/StepThree/StepThree.vue';
import StepFour from '@/components/JobDescription/StepFour/StepFour.vue';
import StepFive from '@/components/JobDescription/StepFive/StepFive.vue';
import StepSix from '@/components/JobDescription/StepSix/StepSix.vue';
import StepSeven from "@/components/JobDescription/StepSeven/StepSeven.vue";

export default {
  components: {
    ProgressBar,
    StepOne,
    StepTwo,
    StepThree,
    StepFour,
    StepFive,
    StepSix,
    StepSeven,
  },
  created() {
    const stepParam = parseInt(this.$route.params.step);
    this.step = isNaN(stepParam) || stepParam < 1 || stepParam > this.totalSteps ? 1 : stepParam;
  },
  data() {
    return {
      step: 1,
      totalSteps: 7,
    };
  },
  methods: {
    nextStep() {
      this.step += 1;
      this.$router.push({ name: 'job_description', params: { organizationId: parseInt(this.$route.params.organizationId), step: this.step } });
      window.scrollTo(0, 0);
    },
    prevStep() {
      this.step -= 1;
      this.$router.push({ name: 'job_description', params: { organizationId: parseInt(this.$route.params.organizationId), step: this.step } });
      window.scrollTo(0, 0);
    },
  },
};
</script>
